<template>
    <div class="head" :style="{background:headObj?headObj.backgroundc:'#000',color:headObj?headObj.color:'#fff'}">
      <img class="head-left" src="./../assets/back.png" alt="" @click="on_back">
      <span>{{headObj?headObj.title:'弹幕红警大乱斗'}}</span>
      <span class="head-right"></span>
    </div>
</template>

<script>
export default {
  name: 'myHead',
  data () {
    return {

    }
  },
  props: {
    headObj: {type: Object, default: () => {}}
  },
  methods: {
    on_back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.head{background: #000;color: #fff;font-size: 0.36rem;display: flex;justify-content: space-between;align-items: center;height: 0.9rem;padding: 0 0.22rem;}
.head-left,.head-right{display: inline-block;width: 14px;cursor: pointer;}
.head-left{width: 20px;height: 20px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/header.vue